module.exports = __webpack_public_path__ + "static/media/warning.33e5e4c1.svg";